export interface Behfa_Interface {
    id:number,
    val:string,
    type:number,
    create_user:String,
    create_date:String,
    update_user:String,
    update_date:String,
    del:boolean,
    deletingProccess:boolean,
  }
  
  export function Empty_Behfa_Interface():Behfa_Interface{
    return{
      id:0,
      val:'',
      type:0,
      create_user:'',
      create_date:'',
      update_user:'',
      update_date:'',
      del:false,
      deletingProccess:false,
    }
  }
  